import { useMemo } from 'react';
import { 
  heroData, 
  aboutData, 
  technologyData, 
  platformData, 
  clinicalApplicationsData,
  patentData,
  manufacturingData,
  capabilitiesData
} from '../constants/homeData.tsx';

/**
 * Custom hook providing centralized access to all home page data
 * @returns Memoized home page data object
 */
export const useHomeData = () => {
  return useMemo(() => ({
    hero: heroData,
    about: aboutData,
    technologies: technologyData,
    platforms: platformData,
    clinicalApplications: clinicalApplicationsData,
    patents: patentData,
    manufacturing: manufacturingData,
    capabilities: capabilitiesData
  }), []);
};
